import { Config } from "../../../configurations/config";

export const ResourceProjectHoursAPIs = {
	GetEmployeeList: `${Config.server_url}${Config.api_prefix}/Employee/GetAllEmployees`,
	GetSupervisorsEmployeesList: `${Config.server_url}${Config.api_prefix}/Employee/GetSupervisorsEmployeesList`,
	GetEmployeeProjectHours: `${Config.server_url}${Config.api_prefix}/TimeSheet/ResourceProjectHours`,
	ExportToExcel: `${Config.server_url}${Config.api_prefix}/TimeSheet/ResourceProjectHours/ExportToExcel`,
	GetDevOpsTasks: `${Config.server_url}${Config.api_prefix}/TimeSheet/GetDevOpsLoggedHours`,
};
